<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Báo cáo tiến độ vào điểm</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <ExamProgressReportFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <ExamProgressReportCard :selectedSemester="selectedSemester" />
    </v-card>
  </div>
</template>

<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import ExamProgressReportFilter from '@/modules/exam/ExamProgressReportFilter.vue'
import ExamProgressReportCard from '@/modules/exam/ExamProgressReportCard.vue'

export default {
  components: {
    StudentBlankView,
    ExamProgressReportFilter,
    ExamProgressReportCard
  },
  data() {
    return {
      action: { state: 'select' },
      selectedSemester: null
    }
  },
  methods: {
    onFilterChanged(semester) {
      this.action.state = 'filtered'
      this.selectedSemester = semester
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
